import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root' // Makes the service available globally
})
export class FeatureToggleService {
  private featureToggles: any[] = [];

  constructor(private http: HttpClient) {}

  // Load the JSON file
  loadFeatureToggles(): Observable<any[]> {
    return this.http.get<any[]>('/assets/data/feature-toggle.json').pipe(
      map((data) => {
        this.featureToggles = data;
        return data;
      })
    );
  }

  // Get the toggle value for a specific feature
  isFeatureEnabled(feature: string): boolean {
    const featureToggle = this.featureToggles.find((f) => f.feature === feature);
    if(featureToggle?.toggle === "Y")
        return true;
    else 
        return false;
  }
}